import React from "react";

const DoubtsEmpty = () => {
    return (
        <>
            <div className="flex justify-between px-4 w-full">
                <div className="text-lg text-gray-600">
                    -- No Doubts Posted --
                </div>
            </div>
        </>
    );
}

export default DoubtsEmpty;